import axios from 'axios'
import _ from 'lodash'
import { validateTime } from '@/utils/timeValidator'

// state
const state = {
	files: {}, 					// all files belonging to job
	deleteFile: {}, 			// temporarily hold selected file to delete
	canUploadFile: false,
	selectedFile: {},			// track selection of uploaded files
	showUploadLoader: false,	// upload loader
	errorMsg: '',
	showErrorMsg: false,
	digitalFormData: {}, 		// store input data
	arrival_time_error: false,
	start_time_error: false,
	end_time_error: false,
	invalid_arrival_time_error: false,
	invalid_start_time_error: false,
	invalid_end_time_error: false,
	authorizer_name_error: false,
	authorizer_phone_error: false,
	authorizer_signature_error: false,
	canSave: false,
	saveLoader: false,
	submitToServer: false,
	html: '',
	html_client: '',

	// non-logged
	alreadyUploaded: false,
	invalidToken: false,
	uploadSuccess: false,
	timeNotAllowed: false,
	guest: false,				// we'll use this to track non-logged user
	data: {},
	formData: {},

	generateClientVos: false, 	// will use this to generate VOS for client
	canSubmitServer: true,
}

const getters = {
	getSelectedFile(state) {
		return state.selectedFile
	},
	getshowUploadLoader(state) {
		return state.showUploadLoader
	},
	getshowErrorMsg(state) {
		return state.showErrorMsg
	},
	geterrorMsg(state) {
		return state.errorMsg
	},
	getdigitalFormData(state) {
		return state.digitalFormData
	},
	getcanSave(state) {
		return state.canSave
	},
	getsaveLoader(state) {
		return state.saveLoader
	}
}


// mutations
const mutations = {
	SET_VARIABLE(state, { key, value }) {
		eval('state.' + key + ' = value');
	},

	ADD_UPLOADED_FILE(state, { files }) {
		state.files.push(files);
	},

	UPDATE_SELECTED_DATA(state, { key, value }) {
		state.digitalFormData[key] = value;
	},

	SET_PAGE_REFRESH(state) {
		sessionStorage.setItem("DIGITAL-FORM-DATA", JSON.stringify(state.digitalFormData))
	},

	SET_PAGE_DONE(state) {
		if (sessionStorage.getItem("DIGITAL-FORM-DATA") !== null && sessionStorage.getItem("DIGITAL-FORM-DATA") !== '' && sessionStorage.getItem("DIGITAL-FORM-DATA") !== 'undefined') {
			state.digitalFormData = JSON.parse(sessionStorage.getItem("DIGITAL-FORM-DATA"))
		}
		sessionStorage.removeItem("DIGITAL-FORM-DATA")
	}
}

// actions
const actions = {
	pageRefresh({ commit }) {
		//console.log("pageRefersh")
		commit('SET_PAGE_REFRESH')
	},

	pageDone({ commit, dispatch }) {
		//console.log("pageDone")
		commit('SET_PAGE_DONE')
	},

	setVariable({ commit }, { key, value }) {
		commit('SET_VARIABLE', { key: key, value: value });
	},

	updateSelectedData({ commit }, key, value) {
		commit('UPDATE_SELECTED_DATA', key, value)
		
		// reset submit to server error variable.
		commit('SET_VARIABLE', { key: 'canSubmitServer', value: true });
	},

	// get files
	getFiles({ commit, state, dispatch, getters, rootState, rootGetters }) {
		var header = rootState.auth.header;
		var client_request_id = rootState.requests.formData[0].client_request_id;
		var url = rootState.auth.l + 'v1/request-vos?client_request_id=' + client_request_id;

		axios.get(url, header)
			.then(response => {
				var files = response.data.data;
				commit('SET_VARIABLE', { key: 'files', value: files });
			}).catch((error) => {
				console.log(error);
			});
	},

	// upload scanned VOS
	uploadFile({ commit, state, dispatch, getters, rootState, rootGetters }, file) {
		if (file.type == 'image/png' || file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'application/pdf') {

			commit('SET_VARIABLE', { key: 'showUploadLoader', value: true });
			var header = {
				...rootState.auth.header,
				headers: { ...(rootState.auth.header.headers || {}), 'Content-Type': 'multipart/form-data' },
			};
			var request = rootState.requests.formData[0];

			let formData = new FormData();
			formData.append('file', file);
			formData.append('client_request_id', request.client_request_id);
			formData.append('digital', 0);  // set digital signature to false

			var url = rootState.auth.l + 'v1/request-vos';

			axios.post(url, formData, header)
				.then(response => {
					commit('SET_VARIABLE', { key: 'showUploadLoader', value: false });

					if (response.data.status != 202) {
						// show file successfull upload modal
						VueStore.dispatch('notify/setShowMessage', { key: 'showUploadFileSuccess', bool: true });

						// append new file to completed vos list
						var newFile = response.data.data;
						//console.log(newFile);
						commit('ADD_UPLOADED_FILE', { files: newFile });

						// reset table
						VueStore.dispatch('datatable/resetDatatable');
					} else {
						commit('SET_VARIABLE', { key: 'timeNotAllowed', value: true });

					}
				}).catch((error) => {
					console.log(error);
					commit('SET_VARIABLE', { key: 'showUploadLoader', value: false });
				});

		} else {
			// show error message
			var errorMessage = 'File type is not supported. Please only upload PDF, JPG or PNG file.';
			commit('SET_VARIABLE', { key: 'errorMsg', value: errorMessage })
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
		}

	},
	// push selected file to delete to vuex
	pushToFileDelete({ commit, state, dispatch, getters, rootState, rootGetters }, id) {
		var files = state.files; // this will contain all files

		// filter by id
		var fileToDelete = files.filter(item => item.id == id);

		commit('SET_VARIABLE', { key: 'deleteFile', value: fileToDelete });
	},

	// delete vos file
	deleteFile({ commit, state, dispatch, getters, rootState, rootGetters }) {
		commit('SET_VARIABLE', { key: 'showUploadLoader', value: true });
		var header = rootState.auth.header;
		var deleteFile = state.deleteFile[0];
		var id = deleteFile.id;

		// update the server
		var url = rootState.auth.l + 'v1/request-vos/' + id;
		axios.delete(url, header)
			.then(response => {
				// show modal for successful deletion
				VueStore.dispatch('notify/setShowMessage', { key: 'showDeleteVosSuccess', bool: true });

				// remove the deleted id from all job files
				var jobFiles = state.files;
				var updatedJobFiles = jobFiles.filter(item => item.id != id);
				commit('SET_VARIABLE', { key: 'files', value: updatedJobFiles });
				commit('SET_VARIABLE', { key: 'showUploadLoader', value: false });

				// reset table
				VueStore.dispatch('datatable/resetDatatable');

			}).catch((error) => {
				console.log(error);
				commit('SET_VARIABLE', { key: 'showUploadLoader', value: false });
			});
	},

	// saves digital signature
	saveDigital({ commit, state, dispatch, rootState }) {

		commit('SET_VARIABLE', { key: 'saveLoader', value: true });

		// check for required fields
		dispatch('checkRequiredFields');
		var submitRequest = state.submitToServer;

		if (submitRequest) {

			var header = {};
			var url = '';


			let formData = new FormData();

			// generate VOS for vendor/staff
			dispatch('createHTML');

			// generate VOS for client
			dispatch('createHTML', true);

			// for non-logged in user
			if (state.guest == true) {
				header = {
					headers: {
					}
				}
				header['headers']['Content-Type'] = 'multipart/form-data';
				url = rootState.auth.l + 'vos/capture';
				formData.append('id', state.data.id);
				commit('UPDATE_SELECTED_DATA', {key: 'id', value: state.data.id})
				formData.append('token', state.data.token);
				commit('UPDATE_SELECTED_DATA', {key: 'token', value: state.data.token})
				formData.append('email', state.digitalFormData.email);
			} else {
				header = {
					...rootState.auth.header,
					headers: { ...(rootState.auth.header.headers || {}), 'Content-Type': 'multipart/form-data' },
				};
				url = rootState.auth.l + 'v1/request-vos';
			}

			formData.append('body', state.html);
			formData.append('client_request_id', state.digitalFormData.client_request_id);
			formData.append('digital', 1);  // set digital signature to true

			axios.post(url, formData, header)
				.then(response => {
					commit('SET_VARIABLE', { key: 'saveLoader', value: false });
					formData.delete('body');   //delete vendor HTML version
					formData.append('body', state.html_client); //add client HTML version
					formData.append('show_client', 1);  // show to client

					if (state.guest != true) {
						if (response.data.status != 202) {
							// append new file to completed vos list
							var newFile = response.data.data;
							//console.log(newFile);
							commit('ADD_UPLOADED_FILE', { files: newFile });

							dispatch('notify/setShowMessage', { key: 'viewDigitalVosModal', bool: false }, { root: true });
							// reset table
							VueStore.dispatch('datatable/resetDatatable');
							// save a version for client.
							dispatch('saveClientDigital', {'url': url, 'formData': formData, 'header': header});

							// Save job actuals
							VueStore.dispatch('requestActual/createForLoggedUser');
						} else {
							commit('SET_VARIABLE', { key: 'timeNotAllowed', value: true });
						}
					} else {
						if (typeof (response.data.status) !== 'undefined') {
							switch (response.data.status) {
								case '200':
									commit('SET_VARIABLE', { key: 'uploadSuccess', value: true });
									commit('SET_VARIABLE', { key: 'guest', value: false });
									// save a version for client.
									dispatch('saveClientDigital', {'url': url, 'formData': formData, 'header': header});

									// Save job actuals
									VueStore.dispatch('requestActual/createForNonLoggedUser');
									break;
								case '400':
								case '404':
									commit('SET_VARIABLE', { key: 'invalidToken', value: true });
									break;
								case '202':
									commit('SET_VARIABLE', { key: 'timeNotAllowed', value: true });
									break;
							}
						}
					}
				}).catch((error) => {
					console.log("error", error);
					commit('SET_VARIABLE', { key: 'saveLoader', value: false });
				});
		}

	},

	// save client's version
	saveClientDigital({ commit, state, dispatch, rootState }, payload) {
		axios.post(payload.url, payload.formData, payload.header)
			.then(response => {
				console.log("response scd", response)
			}).catch((error) => {
				console.log("error", error);
			});
	},


	checkRequiredFields({ commit, state, dispatch }) {
		var data = state.digitalFormData;
		var errorCount = 0;

		if (typeof data.arrival_time === 'undefined' || data.arrival_time === '' || data.arrival_time === null || !validateTime(data.arrival_time)) {
			errorCount += 1;
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
			commit('SET_VARIABLE', { key: 'arrival_time_error', value: true })
			if(!validateTime(data.arrival_time)){
				commit('SET_VARIABLE', { key: 'invalid_arrival_time_error', value: true })
			}
		}

		if (typeof data.start_time === 'undefined' || data.start_time === '' || data.start_time === null || !validateTime(data.start_time)) {
			errorCount += 1;
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
			commit('SET_VARIABLE', { key: 'start_time_error', value: true })
			if(!validateTime(data.start_time)){
				commit('SET_VARIABLE', { key: 'invalid_start_time_error', value: true })
			}
		}

		if (typeof data.end_time === 'undefined' || data.end_time === '' || data.end_time === null || !validateTime(data.end_time)) {
			errorCount += 1;
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
			commit('SET_VARIABLE', { key: 'end_time_error', value: true })
			if(!validateTime(data.end_time)){
				commit('SET_VARIABLE', { key: 'invalid_end_time_error', value: true })
			}
		}

		if ((typeof data.authorizer_name === 'undefined' || data.authorizer_name === '' || data.authorizer_name === null) && state.digitalFormData.job_type_id == 1) {
			errorCount += 1;
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
			commit('SET_VARIABLE', { key: 'authorizer_name_error', value: true })
		}

		if ((typeof data.authorizer_phone === 'undefined' || data.authorizer_phone === '' || data.authorizer_phone === null) && state.digitalFormData.job_type_id == 1) {
			errorCount += 1;
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
			commit('SET_VARIABLE', { key: 'authorizer_phone_error', value: true })
		}

		if (typeof data.authorizer_signature === 'undefined' || data.authorizer_signature === '' || data.authorizer_signature === null) {
			errorCount += 1;
			commit('SET_VARIABLE', { key: 'showErrorMsg', value: true })
			commit('SET_VARIABLE', { key: 'authorizer_signature_error', value: true })
		}

		if (errorCount > 0) {
			commit('SET_VARIABLE', { key: 'saveLoader', value: false })
			commit('SET_VARIABLE', { key: 'submitToServer', value: false })
			commit('SET_VARIABLE', { key: 'canSubmitServer', value: false })
		} else {
			commit('SET_VARIABLE', { key: 'submitToServer', value: true })
			commit('SET_VARIABLE', { key: 'canSubmitServer', value: true })
		}

	},

	createHTML({ commit, state, dispatch }, generateForClient = false) {
		var digitalFormData = state.digitalFormData;
		var html = '';

		html += "<div class='print-request'>";
		html += "<div class='columns'>";
		html += "<div class='column is-12'>";
		html += "<div class='columns'>";
		html += "<table class='heading'>";
		html += "<tr>";
		html += "<td><div class='job-number'>Job# " + digitalFormData.job_no + "</div></td>";
		html += "</tr>";
		html += "</table>";
		html += "</div>";
		html += "<div class='columns'>";
		html += "<div class='column is-12'>";
		html += "<table>";
		html += "<thead>";
		html += "<tr>";
		html += "<th colspan='2'>Verification of Service</th>";
		html += "</tr>";
		html += "</thead>";
		html += "<tbody>";

		html += "<tr>";
		html += "<td style='width: 200px;'>Job #</td>";
		html += "<td>" + digitalFormData.job_no + "</td>";
		html += "</tr>";
		html += "<tr>";
		html += "<td style='width: 200px;'>Service Date</td>";
		html += "<td>" + digitalFormData.service_date + "</td>";
		html += "</tr>";
		html += "<tr>";
		html += "<td style='width: 200px;'>Service Time</td>";
		html += "<td>" + digitalFormData.service_time + "</td>";
		html += "</tr>";
		/* html += "<tr>";
			html += "<td style='width: 200px;'>LEP/Case Name</td>";
			html += "<td>"+(digitalFormData.case_name_lep == null ? '\u00A0' : digitalFormData.case_name_lep)+"</td>";
		html += "</tr>";
		*/
		if (digitalFormData.client_id == 916) {
			html += "<tr>";
			html += "<td style='width: 200px;'>Case #/MRN</td>";
			html += "<td>" + (digitalFormData.case_num_mrn == null ? '\u00A0' : digitalFormData.case_num_mrn) + "</td>";
			html += "</tr>";
		}
		/*
		html += "<tr>";
			html += "<td style='width: 200px;'>Service Description</td>";
			html += "<td>"+(digitalFormData.service_description == null ? '\u00A0' :  digitalFormData.service_description)+"</td>";
		html += "</tr>"; */
		if (digitalFormData.job_type_id == 1) {
			html += "<tr>";
			html += "<td style='width: 200px;'>Location</td>";
			html += "<td>" + (digitalFormData.location_name == null ? '\u00A0' : digitalFormData.location_name) + "</td>";
			html += "</tr>";
		}
		/*html += "<tr>";
			html += "<td style='width: 200px;'>Address/Department</td>";
			html += "<td>"+(digitalFormData.dept_num == null ? '\u00A0' : digitalFormData.dept_num)+"</td>";
		html += "</tr>";
		html += "<tr>";
			html += "<td style='width: 200px;'>Facilitator</td>";
			html += "<td>"+(digitalFormData.contact_name == null ? '\u00A0' : digitalFormData.contact_name)+"</td>";
		html += "</tr>"; */
		html += "<tr>";
		html += "<td style='width: 200px;'>" + (digitalFormData.job_type_id == 1 ? 'Interpreter Arrival Time' : 'Logged In Time') + "</td>";
		html += "<td>" + digitalFormData.arrival_time + "</td>";
		html += "</tr>";
		html += "<tr>";
		html += "<td style='width: 200px;'>Start Time</td>";
		html += "<td>" + digitalFormData.start_time + "</td>";
		html += "</tr>";
		html += "<tr>";
		html += "<td style='width: 200px;'>End Time</td>";
		html += "<td>" + digitalFormData.end_time + "</td>";
		html += "</tr>";
		if (digitalFormData.job_type_id == 1) {
			html += "<tr>";
			html += "<td style='width: 200px;'>Authorizer Name (First & Last)</td>";
			html += "<td>" + digitalFormData.authorizer_name + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Authorizing Phone Number</td>";
			html += "<td>" + digitalFormData.authorizer_phone + "</td>";
			html += "</tr>";
		}
		html += "<tr>";
		html += "<td style='width: 200px;'>Authorizing Signature</td>";
		html += "<td><img style='width: 300px;' src='" + digitalFormData.authorizer_signature + "'/></td>";
		html += "</tr>";
		html += "<tr>";
		html += "<td style='width: 200px;'>Interpreter Name</td>";
		html += "<td>" + digitalFormData.vendor_full_name + "</td>";
		html += "</tr>";
		html += "<tr>";
		html += "<td style='width: 200px;'>Language</td>";
		html += "<td>" + digitalFormData.target_language + "</td>";
		html += "</tr>";
		/** Show to Elevance */
		if (digitalFormData.client_id == 916) {
			html += "<tr>";
			html += "<td style='width: 200px;'>Patient Was No Show</td>";
			html += "<td>" + (!digitalFormData.patient_no_show ? '\u00A0' : 'Yes') + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Patient Was Late</td>";
			html += "<td>" + (!digitalFormData.patient_late ? '\u00A0' : 'Yes') + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>How Late?</td>";
			html += "<td>" + (!digitalFormData.patient_late_time ? '\u00A0' : digitalFormData.patient_late_time) + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Scheduled Next Appt.</td>";
			html += "<td>" + (!digitalFormData.patient_helped ? '\u00A0' : 'Yes') + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Next Appt. Date</td>";
			html += "<td>" + (!digitalFormData.next_appt_date ? '\u00A0' : digitalFormData.next_appt_date) + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Next Appt. Time</td>";
			html += "<td>" + (!digitalFormData.next_appt_time ? '\u00A0' : digitalFormData.next_appt_time) + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Location</td>";
			html += "<td>" + (!digitalFormData.next_appt_location ? '\u00A0' : digitalFormData.next_appt_location) + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>Service Description</td>";
			html += "<td>" + (!digitalFormData.next_appt_service_description ? '\u00A0' : digitalFormData.next_appt_service_description) + "</td>";
			html += "</tr>";
			html += "<tr>";
			html += "<td style='width: 200px;'>I'm Available.</td>";
			html += "<td>" + (!digitalFormData.next_appt_available ? '\u00A0' : 'Yes') + "</td>";
			html += "</tr>";
		}
		/** /Show to Elevance */

		/** Don't show to client */
		if(generateForClient == false){
			html += "<tr>";
			html += "<td style='width: 200px;'>Interpreter Assignment Notes </td>";
			html += "<td>" + (digitalFormData.vos_notes == null ? '\u00A0' : digitalFormData.vos_notes) + "</td>";
			html += "</tr>";
		}

		html += "</tbody>";
		html += "</table>";
		html += "</div>";
		html += "</div>";

		html += "</div>";
		html += "</div>";
		html += "</div>";
		html += "<br/>";

		html += "<style>";
		html += ".print-request{overflow-y: hidden;overflow-x: hidden;zoom: 80%; font-size: 12px !important;}.print-request .column{padding: 0;}.print-request table{table-layout: auto !important; }.print-request{max-width: 75rem;margin-right: auto;margin-left: auto;}.print-request {padding-right: 2rem;padding-left: 2rem}.print-request .print-request {margin-top: 20px;}.print-request #app {margin: 2.25rem auto;}.print-request h1 {color: #006FC0;font-size: 1.5rem;font-weight: 600; }.print-request table {border-spacing: 0;width: 100%;margin-top: 5px !important;; }.print-request table th {font-weight: 700;color: #006FC0;padding: 5px;background-color: #DBE6F0;font-size: 1.125rem;border: 1px solid #c1c1c1;border-bottom: none; text-align: center !important;}.print-request table tr td {font-size: 0.875rem;padding: 2px;border-left: 1px solid #c1c1c1; border-top: 1px solid #c1c1c1;}.print-request table tr td:first-child {font-weight: bold; }.print-request table tr td:nth-last-child(2) {border-right: 1px solid #c1c1c1;}.print-request table tr:last-child td{border-bottom: 1px solid #c1c1c1;}.print-request .job-number {font-size: 1.25rem;text-align: right;margin-top: 0.25rem; }.print-request .internal-use {background-color: #E6B7B8;color: #632324;}.print-request table.heading tr td{padding: 0 !important; border: none !important;}";
		html += "";
		html += "";

		html += "</style>";

		if(generateForClient){
			commit('SET_VARIABLE', { key: 'html_client', value: html });
		}else{
			commit('SET_VARIABLE', { key: 'html', value: html });
		}

	},

	checkToken({ commit, dispatch, rootState }, data) {
		var url = rootState.auth.l + 'vos/check-token';
		// pass it to api and check to make sure token exist & is not expired
		axios.post(url, data)
			.then(response => {
				//console.log("response", response.data.status)
				if (response.data.data !== '') {
					var data = response.data.data.original.data;
					commit('SET_VARIABLE', { key: 'digitalFormData', value: data[0] });
				}

				if (typeof (response.data.status) !== 'undefined') {
					switch (response.data.status) {
						case '200':
							commit('SET_VARIABLE', { key: 'guest', value: true });
							break;
						case '400':
						case '404':
							commit('SET_VARIABLE', { key: 'invalidToken', value: true });
							break;
						case '202':
							commit('SET_VARIABLE', { key: 'alreadyUploaded', value: true });
							break;
					}
				}
			})
			.catch((error) => {
				console.log(error);
			});
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}